import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import PaymentMethodList from "../pages/PaymentMethod/PaymentMethodList";
import CreatePaymentMethod from "../pages/PaymentMethod/CreatePaymentMethod";
import EditPaymentMethod from "../pages/PaymentMethod/EditPaymentMethod";
//@ts-ignore
import {
  PermissionRequired,
  AccessControl,
} from "@careinfo/permission-required";

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route
            path="/"
            element={
              <AccessControl
                children={<PaymentMethodList />}
                allowedPermissions={["can_view_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/payment-method"
            element={
              <AccessControl
                children={<PaymentMethodList />}
                allowedPermissions={["can_view_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/create"
            element={
              <AccessControl
                children={<CreatePaymentMethod />}
                allowedPermissions={["can_create_payment_method"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/edit/:id"
            element={
              <AccessControl
                children={<EditPaymentMethod />}
                allowedPermissions={["can_update_payment_method"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
